import { createContext, useContext } from 'react';

/**
 * State a {@link FolioDrawer} shares with its contents.
 *
 * @typedef {object} FolioDrawerContextValue
 * @property {(event?: Event) => void} onClose Closes the drawer straight away, without the
 *   leave-confirm. Used by the header's close button.
 * @property {boolean} canMaximise Whether the maximise toggle is shown.
 * @property {boolean} isMaximised Whether the panel is currently full width.
 * @property {(update: boolean | ((prev: boolean) => boolean)) => void} setIsMaximised
 * @property {(isDirty: boolean) => void} setIsFormDirty Used by `FolioDrawerFormGuard`.
 */

/** Context provided by {@link FolioDrawer}; `null` outside a drawer. */
export const FolioDrawerContext = createContext(null);

/**
 * Reads the surrounding drawer's state.
 *
 * @returns {FolioDrawerContextValue | null} `null` when not rendered inside a FolioDrawer.
 */
export const useFolioDrawerContext = () => useContext(FolioDrawerContext);
